const display = "standalone";

module.exports = display;
